import React from 'react';
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames'
import {NavLink } from 'react-router-dom'

const ButtonPrimary = ({
  to,
  children,
  className,
  primary,
  ghost,
  fancy,
  text,
  type,
  link,
  icon,
  onClick }) => {
  const buttonType = primary ? 'primary' : ghost ? 'ghost' : text ? 'text' : fancy ? 'fancy' : "";

  let _iconEl

  if (icon) { _iconEl = <FontAwesomeIcon className="button-icon" icon={icon} /> }

  if (link) {
    return (
      <a className={classnames({[`button-${buttonType}`]: true}, "button", className)} href={to} target="_blank" rel="noopener noreferrer">{children}{_iconEl}</a>
    )
  }

  if (onClick) {
    return (
      <button className={classnames({[`button-${buttonType}`]: true}, "button", className)} type={type || null} onClick={onClick} href={to} target="_blank" rel="noopener noreferrer">{children}</button>
    )
  }

  return (
    <NavLink className={classnames({[`button-${buttonType}`]: true}, "button", className)} to={to}>{children}</NavLink>
  )
}

ButtonPrimary.propTypes = {
  to: PropTypes.string,
  type: PropTypes.string,
  link: PropTypes.bool,
  primary: PropTypes.bool,
  ghost: PropTypes.bool,
  text: PropTypes.bool,
  onClick: PropTypes.func
}

export default ButtonPrimary;
